
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("JSoWM", function(module, exports) {
$parcel$export(module.exports, "FooterLabels", () => (parcelRequire("1xzIe")).FooterLabels);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $1xzIe = parcelRequire("1xzIe");


});

parcelRegister("hysf6", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $jmjWc = parcelRequire("jmjWc");


const $4119a6166d969e95$var$DetailsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "TmpiW",
    name: "DetailsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("e78n7"))).DetailsPanelHeaderIcon
});

const $4119a6166d969e95$var$DetailsPanelBody = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "WdQRW",
    name: "DetailsPanelBody",
    loader: async ()=>(await (parcelRequire("8Fcge"))).DetailsPanelBody
});
const $4119a6166d969e95$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    detailsPanelHeaderLabel: {
        id: "details-panel.panel.header.label",
        defaultMessage: "Details"
    }
});
const $4119a6166d969e95$export$fd546c83bdd1393d = ()=>{
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const showDetailsPanel = ({ highlightLabels: highlightLabels } = {})=>{
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).DetailsPanel,
            headerComponentElements: {
                HeaderIcon: $4119a6166d969e95$var$DetailsPanelHeaderIcon,
                headerLabel: $4119a6166d969e95$export$a7357cdd1f0b0168.detailsPanelHeaderLabel
            },
            BodyComponent: $4119a6166d969e95$var$DetailsPanelBody,
            props: {
                highlightLabels: highlightLabels
            }
        }, 'push');
    };
    return {
        isDetailsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).DetailsPanel,
        showDetailsPanel: showDetailsPanel
    };
};
module.exports["useShowDetailsPanel"] = $4119a6166d969e95$export$fd546c83bdd1393d;

});

parcelRegister("e78n7", function(module, exports) {

let $a46836a435902b70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a46836a435902b70$var$load("h4ycT"),
    $a46836a435902b70$var$load("aDBL0"),
    $a46836a435902b70$var$load("5A9du"),
    $a46836a435902b70$var$load("9aQIt"),
    $a46836a435902b70$var$load("XZauT"),
    $a46836a435902b70$var$load("4S1SF"),
    $a46836a435902b70$var$load("jiFtb"),
    $a46836a435902b70$var$load("lm9Lt"),
    $a46836a435902b70$var$load("9wPDc"),
    $a46836a435902b70$var$load("1MWOL"),
    $a46836a435902b70$var$load("6fQco"),
    $a46836a435902b70$var$load("aOY32"),
    $a46836a435902b70$var$load("a08Vk"),
    $a46836a435902b70$var$load("jtwfh"),
    $a46836a435902b70$var$load("9ZkgN"),
    $a46836a435902b70$var$load("lesgd"),
    $a46836a435902b70$var$load("5OMvV"),
    $a46836a435902b70$var$load("lnnYm"),
    $a46836a435902b70$var$load("c831e"),
    $a46836a435902b70$var$load("62Uuv"),
    $a46836a435902b70$var$load("ls6cF"),
    $a46836a435902b70$var$load("l4YAS"),
    $a46836a435902b70$var$load("h4Nf7"),
    $a46836a435902b70$var$load("5uN9h"),
    $a46836a435902b70$var$load("6LocR"),
    $a46836a435902b70$var$load("gQg2m"),
    $a46836a435902b70$var$load("Wowvf"),
    $a46836a435902b70$var$load("eY3St"),
    $a46836a435902b70$var$load("bkd4T"),
    $a46836a435902b70$var$load("hv4mn"),
    $a46836a435902b70$var$load("dek7I"),
    $a46836a435902b70$var$load("dYtBN"),
    $a46836a435902b70$var$load("kNV5Y"),
    $a46836a435902b70$var$load("kjZZD"),
    $a46836a435902b70$var$load("e6ams"),
    $a46836a435902b70$var$load("iVgrO"),
    $a46836a435902b70$var$load("7EorR"),
    $a46836a435902b70$var$load("dRpV3"),
    $a46836a435902b70$var$load("dTsOE"),
    $a46836a435902b70$var$load("hhss7"),
    $a46836a435902b70$var$load("h7SKv"),
    $a46836a435902b70$var$load("ac63V"),
    $a46836a435902b70$var$load("ixG3z"),
    $a46836a435902b70$var$load("4t5KN"),
    $a46836a435902b70$var$load("3QIea"),
    $a46836a435902b70$var$load("iMPw4"),
    $a46836a435902b70$var$load("h3ABO"),
    $a46836a435902b70$var$load("kC80R"),
    $a46836a435902b70$var$load("6wr18"),
    $a46836a435902b70$var$load("ffEVr"),
    $a46836a435902b70$var$load("8zlfy")
]).then(()=>parcelRequire('7N9MO'));

});

parcelRegister("8Fcge", function(module, exports) {

let $64eba9c89f3764e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $64eba9c89f3764e6$var$load("h4ycT"),
    $64eba9c89f3764e6$var$load("aDBL0"),
    $64eba9c89f3764e6$var$load("5A9du"),
    $64eba9c89f3764e6$var$load("9aQIt"),
    $64eba9c89f3764e6$var$load("XZauT"),
    $64eba9c89f3764e6$var$load("4S1SF"),
    $64eba9c89f3764e6$var$load("jiFtb"),
    $64eba9c89f3764e6$var$load("lm9Lt"),
    $64eba9c89f3764e6$var$load("9wPDc"),
    $64eba9c89f3764e6$var$load("1MWOL"),
    $64eba9c89f3764e6$var$load("6fQco"),
    $64eba9c89f3764e6$var$load("aOY32"),
    $64eba9c89f3764e6$var$load("a08Vk"),
    $64eba9c89f3764e6$var$load("jtwfh"),
    $64eba9c89f3764e6$var$load("9ZkgN"),
    $64eba9c89f3764e6$var$load("lesgd"),
    $64eba9c89f3764e6$var$load("5OMvV"),
    $64eba9c89f3764e6$var$load("lnnYm"),
    $64eba9c89f3764e6$var$load("c831e"),
    $64eba9c89f3764e6$var$load("62Uuv"),
    $64eba9c89f3764e6$var$load("ls6cF"),
    $64eba9c89f3764e6$var$load("l4YAS"),
    $64eba9c89f3764e6$var$load("h4Nf7"),
    $64eba9c89f3764e6$var$load("5uN9h"),
    $64eba9c89f3764e6$var$load("6LocR"),
    $64eba9c89f3764e6$var$load("gQg2m"),
    $64eba9c89f3764e6$var$load("Wowvf"),
    $64eba9c89f3764e6$var$load("eY3St"),
    $64eba9c89f3764e6$var$load("bkd4T"),
    $64eba9c89f3764e6$var$load("hv4mn"),
    $64eba9c89f3764e6$var$load("dek7I"),
    $64eba9c89f3764e6$var$load("dYtBN"),
    $64eba9c89f3764e6$var$load("kNV5Y"),
    $64eba9c89f3764e6$var$load("kjZZD"),
    $64eba9c89f3764e6$var$load("e6ams"),
    $64eba9c89f3764e6$var$load("iVgrO"),
    $64eba9c89f3764e6$var$load("7EorR"),
    $64eba9c89f3764e6$var$load("dRpV3"),
    $64eba9c89f3764e6$var$load("dTsOE"),
    $64eba9c89f3764e6$var$load("hhss7"),
    $64eba9c89f3764e6$var$load("h7SKv"),
    $64eba9c89f3764e6$var$load("ac63V"),
    $64eba9c89f3764e6$var$load("ixG3z"),
    $64eba9c89f3764e6$var$load("4t5KN"),
    $64eba9c89f3764e6$var$load("3QIea"),
    $64eba9c89f3764e6$var$load("iMPw4"),
    $64eba9c89f3764e6$var$load("h3ABO"),
    $64eba9c89f3764e6$var$load("kC80R"),
    $64eba9c89f3764e6$var$load("6wr18"),
    $64eba9c89f3764e6$var$load("ffEVr"),
    $64eba9c89f3764e6$var$load("8zlfy")
]).then(()=>parcelRequire('9igqG'));

});

parcelRegister("4vaoM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a85e440150ad6165$export$761f49b4caa7a581 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "JXn3W",
    name: "EditLabelDialogLoader",
    loader: async ()=>(await (parcelRequire("6NjcR"))).EditLabelDialogComponent
});
module.exports["EditLabelDialogLoader"] = $a85e440150ad6165$export$761f49b4caa7a581;

});

parcelRegister("6NjcR", function(module, exports) {

let $4f2637af9c4e3b76$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f2637af9c4e3b76$var$load("eY3St"),
    $4f2637af9c4e3b76$var$load("bkd4T"),
    $4f2637af9c4e3b76$var$load("6wr18"),
    $4f2637af9c4e3b76$var$load("bL9LM"),
    $4f2637af9c4e3b76$var$load("7EorR"),
    $4f2637af9c4e3b76$var$load("ffEVr"),
    $4f2637af9c4e3b76$var$load("jigcs"),
    $4f2637af9c4e3b76$var$load("1fnbu")
]).then(()=>parcelRequire('m0wkE'));

});

parcelRegister("gfIPU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("1xzIe", function(module, exports) {
/** @graphql cc **/ 
var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $eSUdr = parcelRequire("eSUdr");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $5nBzc = parcelRequire("5nBzc");


var $dcJ7R = parcelRequire("dcJ7R");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $av0Vd = parcelRequire("av0Vd");


var $3gadb = parcelRequire("3gadb");


var $ep3mz = parcelRequire("ep3mz");


var $b3j2Y = parcelRequire("b3j2Y");


var $8aF6s = parcelRequire("8aF6s");


var $hysf6 = parcelRequire("hysf6");


var $4vaoM = parcelRequire("4vaoM");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");


var $6mKj3 = parcelRequire("6mKj3");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");

const $0edb016a56df6289$export$ef7716fb21e26e68 = ()=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const [spaceKey = ''] = (0, $ep3mz.usePageSpaceKey)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { showDetailsPanel: showDetailsPanel } = (0, $hysf6.useShowDetailsPanel)();
    const labelsShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_LABELS_SHORTCUT)
    });
    const { loading: loading, data: data, error: error } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query FooterLabelsQuery($contentId:ID!){singleContent(id:$contentId){id type operations{operation targetType}labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING}){nodes{id label name prefix}}}}`, {
        variables: {
            contentId: contentId
        }
    });
    if (loading) return null;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE),
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }));
    const content = data?.singleContent;
    const hasEditPermissions = Boolean(content?.operations?.find((item)=>item?.operation === 'update' && item?.targetType === content?.type));
    const labels = content?.labels?.nodes?.filter((node)=>node?.name !== 'favourite' || node?.prefix !== 'my') || [];
    if (labels.length === 0) {
        if (!hasEditPermissions) // don't show anything if user doesn't have edit permissions
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE),
            attributes: {
                hasEditPermissions: hasEditPermissions,
                labelsCount: labels.length
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: (0, $6mKj3.expValEquals)('confluence_comments_cohiti_footer_tooltips', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $0edb016a56df6289$var$i18n.addLabelTooltip) : undefined,
            shortcut: labelsShortcutStrings,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $0edb016a56df6289$var$addLabelsButton,
            onClick: ()=>showModal((0, $4vaoM.EditLabelDialogLoader), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    source: 'labelsFooter'
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($av0Vd))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $0edb016a56df6289$var$i18n.addLabels)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE),
            attributes: {
                labelsCount: labels.length,
                hasEditPermissions: hasEditPermissions
            }
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: (0, $6mKj3.expValEquals)('confluence_comments_cohiti_footer_tooltips', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $0edb016a56df6289$var$i18n.manageLabelsTooltip) : undefined,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        xcss: $0edb016a56df6289$var$labelsContainer,
        onClick: ()=>{
            showDetailsPanel({
                highlightLabels: true
            });
        }
    }, labels.slice(0, 2).map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            key: label?.id
        }, label?.name)), labels.length > 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $0edb016a56df6289$var$additionalLabels
    }, "+", labels.length - 2)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE),
        attributes: {
            labelsCount: labels.length
        }
    }));
};
const $0edb016a56df6289$var$labelsContainer = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100',
    paddingInline: 'space.100',
    paddingBlock: 'space.050',
    height: '32px',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $0edb016a56df6289$var$additionalLabels = (0, $ecnYn.xcss)({
    font: 'font.body.small',
    fontWeight: 'font.weight.bold',
    paddingInline: 'space.050'
});
const $0edb016a56df6289$var$addLabelsButton = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    paddingInline: 'space.150',
    borderRadius: 'radius.small',
    color: 'color.text.subtle',
    font: 'font.body',
    height: '32px',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $0edb016a56df6289$var$i18n = (0, $cgtv4.defineMessages)({
    addLabels: {
        id: "labels-footer.addLabels",
        defaultMessage: "Add labels"
    },
    addLabelTooltip: {
        id: "labels-footer.addLabel-tooltip",
        defaultMessage: "Add label"
    },
    manageLabelsTooltip: {
        id: "labels-footer.manageLabels-tooltip",
        defaultMessage: "Manage labels"
    }
});
module.exports["FooterLabels"] = $0edb016a56df6289$export$ef7716fb21e26e68;

});


//# sourceMappingURL=labels-footer.bf539db6.js.map
